import { ContactConfig } from '../../contact.types';

export default {
  links: [
    {
      label: 'Check out QualityNet for more info on HQR',
      link: 'https://qualitynet.cms.gov/',
    },
  ],
  contactDetails: {
    hours: '8:00 AM - 8:00 PM ET',
    days: 'Monday - Friday',
    email: 'qnetsupport@cms.hhs.gov',
    phone1: '1-866-288-8912 (TRS 711)',
  },
} as ContactConfig;
